import { createSlice } from "@reduxjs/toolkit";
import {
  getUtilityType,
  addPricePerUnitToMonth,
  addUtilities,
  getPricePerUnitToMonth,
  editPricePerUnitToMonth,
  editUtilities,
  getUtilities,
  getUtilitiesMergeBill,
} from "API/UtilityAPI";

const initialState = {
  UtilityType: [],
  AddPricePerUnit: [],
  AddUtility: [],
  PricePerUnit: [],
  EditPricePerUnit: [],
  EditUtility: [],
  Utility: [],
  Merge: [],
  loading: false,
};

export const UtilitySlice = createSlice({
  name: "UtilityState",
  initialState,
  reducers: {
    updateGetUtilityType: (state, action) => {
      state.UtilityType = action.payload;
    },
    updateAddPricePerUnit: (state, action) => {
      state.AddPricePerUnit = action.payload;
    },
    updateAddUtility: (state, action) => {
      state.AddUtility = action.payload;
    },
    updateGetPricePerUnit: (state, action) => {
      state.PricePerUnit = action.payload;
    },
    updateEditPricePerUnit: (state, action) => {
      state.EditPricePerUnit = action.payload;
    },
    updateEditUtility: (state, action) => {
      state.EditUtility = action.payload;
    },
    updateGetUtility: (state, action) => {
      state.Utility = action.payload;
    },
    updateGetMergeBill: (state, action) => {
      state.Merge = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setLoading } = UtilitySlice.actions;
export const { updateGetUtilityType } = UtilitySlice.actions;
export const getUtilityTypeDetail = (value) => async (dispatch) => {
  await getUtilityType(value).then(async (data) => {
    await dispatch(updateGetUtilityType(data));
  });
};

export const { updateAddPricePerUnit } = UtilitySlice.actions;
export const AddPricePerUnitToMontDetails = (value) => async (dispatch) => {
  try {
    const data = await addPricePerUnitToMonth(value);
    dispatch(updateAddPricePerUnit(data));
    console.error(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateAddUtility } = UtilitySlice.actions;
export const AddUtilityDetails = (value) => async (dispatch) => {
  try {
    const data = await addUtilities(value);
    dispatch(updateAddUtility(data));
    console.error(data);
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateGetPricePerUnit } = UtilitySlice.actions;
export const getPricePerUnitDetail = (value) => async (dispatch) => {
  await getPricePerUnitToMonth(value).then(async (data) => {
    await dispatch(updateGetPricePerUnit(data));
  });
};

export const { updateEditPricePerUnit } = UtilitySlice.actions;
export const editPricePerUnitToMontDetails = (value) => async (dispatch) => {
  try {
    const data = await editPricePerUnitToMonth(value);
    dispatch(updateEditPricePerUnit(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateEditUtility } = UtilitySlice.actions;
export const editUtilityDetails = (value) => async (dispatch) => {
  try {
    const data = await editUtilities(value);
    dispatch(updateEditUtility(data));

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const { updateGetUtility } = UtilitySlice.actions;
export const getUtilityDetail = (value) => async (dispatch) => {
  await getUtilities(value).then(async (data) => {
    await dispatch(updateGetUtility(data));
  });
};

export const { updateGetMergeBill } = UtilitySlice.actions;
export const getUtilityMergeBillDetail = (value) => async (dispatch) => {
  await getUtilitiesMergeBill(value).then(async (data) => {
    await dispatch(updateGetMergeBill(data));
  });
};

export default UtilitySlice.reducer;
